import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import React, { useEffect, useRef, useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import { ComplaintContainer, Label } from "../complaint/Complaint.styled";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import SocialDetails from "../../components/SocialCaseTbas/SocialDetails";
import Documents from "../../components/SocialCaseTbas/Documents";
import Thankyou from "../../components/SocialCaseTbas/Thankyou";

import SocialCaseRequest from "../../stores/SocialCaseRequestStore";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import User from "../../stores/UserStore";
import generalStore from "../../stores/GeneralStore";
import Error from "../../components/error";

import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import convertBlobToJson from "../../utils/bolbToJson";
import { useNavigate } from "react-router-dom";
import { NotifyError } from "../../utils/ShowError";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from 'yup';
import isEmpty from "../../../src/utils/objectNull";
import './socialcase.scss'
import Tick from '../../assets/tick.svg'
export const TabWithCount = ({
  children,
  count,
  value,
  fontSize,
  justifyContent,
  isLargeScreen,
}: any) => {
  const ColorAss = General?.ColorAss;
  return (
    <Box
      sx={{
        width: "100%",
        display: "inline-flex",
        alignItems: "center",
        flexDirection: "row-reverse",
        gap: isLargeScreen ? "0.5rem" : "0",
        justifyContent: justifyContent ? justifyContent : "Start",
      }}
    >
      <Typography
        component="span"
        fontSize="0.85rem"
        variant="body2"
        sx={{
          textTransform: "capitalize",
          fontSize: fontSize,
          display: "flex",
          gap: isLargeScreen ? "0.5rem" : "0",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          whiteSpace: 'nowrap',
          marginRight: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "1rem" : "",
        }}
      >
        {children}
      </Typography>
      {count ? (
        <Typography
          component="div"
          variant="body2"
          sx={{
            marginRight: "0.5rem",
            borderRadius: "50%",
            background: count <= value ? General.contrast.contrastBackground ? General.contrast.contrastBackground : 'rgba(98, 170, 81, 1)' :
              value === count - 1 ? General.contrast.contrastBackground
                ? General.contrast.contrastBackground
                : General?.ColorAss :
                //none active
                General.contrast.contrastColor
                  ? General.contrast.contrastColor : "#fff",
            color: value === count - 1 ? "#fff" : General.contrast.contrastBackground ? General.contrast.contrastBackground : ColorAss,
            height: isLargeScreen ? "1rem" : "2rem",
            width: isLargeScreen ? "1rem" : "2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.9rem",
          }}
        >
          {count <= value ? <img src={Tick} alt="" /> : count}
        </Typography>
      ) : null}
    </Box>
  );
};

const SocialCase = () => {
  const [value, setValue] = React.useState(0);
  const [title, setTitle] = React.useState("");
  const [uploadDcumentStatus, setuploadDcumentStatus] = React.useState({
    message: "",
    orderId: "",
  });
  const validationSchema = Yup.object().shape({
    parcelId: Yup.string().required(General?.codeLabels['cm_prclid_rqd']?.label ? General?.codeLabels['cm_prclid_rqd']?.label : "Parcel ID is required").min(9, General?.codeLabels['cm_mob_parcelmin']?.label)
      .max(9, General?.codeLabels['cm_mob_pacelmax']?.label).matches(/^[0-9]+$/, General?.codeLabels['cm_numbererror']?.label),

  });
  // to prevent the rendring of other pages
  type preventOtherScreens = {
    parcelDetails: boolean;
    socialDetails: boolean;
    uploadDcuments: boolean;
  };
  const [preventOtherScreensState, setpreventOtherScreensState] =
    useState<preventOtherScreens>({
      parcelDetails: false,
      socialDetails: true,
      uploadDcuments: true,
    });

  const parcelNumberRef = useRef<HTMLInputElement | null>(null);

  const [parcelPressed, setParcelPressed] = React.useState(false);
  const [getDetailLoader, setGetDetailLoader] = React.useState(false);
  const [submitLoader, setSubmitLoader] = React.useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    ErrorSubscription.unSubscribeAll();
  };

  const handleGetDetails = async () => {
    ErrorSubscription?.unSubscribeAll();
    if (parcelNumberRef.current && parcelNumberRef.current?.value) {
      setGetDetailLoader(true);                                       //Loader will spin if data is enetered
      try {
        await SocialCaseRequest.getParcelDetails({                      //Loader state moved inside IF()
          errorId: "getParcelDetailsError",
          data: {
            parcelId: parcelNumberRef.current!.value,
            personId: User.info.personId as string,
          },
        });
      } catch (error) {
        setGetDetailLoader(false);
        return;
      }

      if (SocialCaseRequest.socialCase.cmTWStatus == "F") {
        let rawMessage =
          SocialCaseRequest.socialCase.cmTWStatusMsg.toLowerCase();
        let result = rawMessage.search("msg");
        let messageOrCode = result === 0 ? "cm_" + rawMessage : rawMessage;
        let eliOrNOt = messageOrCode.indexOf("|");
        let regirId =
          eliOrNOt === -1
            ? messageOrCode
            : messageOrCode.slice(eliOrNOt + 1, 30);
        let mainStatusCode =
          eliOrNOt !== -1 ? messageOrCode.slice(0, eliOrNOt) : messageOrCode;
        let displayeStr =
          eliOrNOt !== -1
            ? General?.codeLabels[mainStatusCode]?.label.replace("%1", regirId)
            : General?.codeLabels[mainStatusCode]?.label;

        ErrorSubscription.subscribe({
          message: displayeStr.split("|"),
          id: "getParcelDetailsError",
        });
        setGetDetailLoader(false);
      } else {
        setpreventOtherScreensState({
          ...preventOtherScreensState,
          socialDetails: false,
        });
        setValue(1);
        setGetDetailLoader(false);
      }
      setGetDetailLoader(false);
    }
  };

  //Remove any !!!
  const onSocialDetailsNext = async ({
    caseDetailsComments,
    familyMember,
    socialStatus,
  }: {
    caseDetailsComments: string;
    familyMember: number;
    socialStatus: string;
  }) => {
    SocialCaseRequest.pushToSocialCase({
      caseDetailsComments,
      familyMember,
      socialStatus,
    });
    setpreventOtherScreensState({
      ...preventOtherScreensState,
      uploadDcuments: false,
    });
    setValue(2);
  };
  const [caseIdRes, setCaseId] = useState()
  const handleSubmit = async (files: Array<File>) => {
    setSubmitLoader(true);
    const socialCase = SocialCaseRequest.socialCase;
    const data = {
      customerName: socialCase.primaryName as string,
      customerAccount: socialCase.customerAccount
        ? (socialCase.customerAccount as string)
        : null,
      emiratesId: socialCase.cmEmiratesId as string,
      tariffType: "Connection Fees",
      dueAmount: Number(socialCase.cmConnectorDue),
      applicationDate: new Date().toISOString(),
      familyMember: Number(socialCase.familyMember),
      socialStatus: socialCase.socialStatus,
      justification: socialCase.caseDetailsComments,
      requestNo: socialCase.toDoCaseId
        ? (socialCase.toDoCaseId as string)
        : null,
      status: null,
      //"comments": caseDetailsComments,
      platform: "web",
      applicationDateStr: new Date().toISOString().substring(0, 10),
      parcelNumber: socialCase.cmParcelId as string,
      personNumber: socialCase.personId as string,
      caseNo: socialCase.toDoCaseId as string | null,
    };
    let response = await SocialCaseRequest.submitSocialCaseDetails({
      errorId: "submitSocialCaseDetailsError",
      data,
    });

    let upData = {
      caseId: response?.result?.caseNo as string | null,
      isEdit: false,
    };
    setCaseId(response?.result?.caseNo)
    if (response?.result?.status == "F") {
      var mesg = response?.result?.statusMessage?.split("|")[0]?.toLowerCase();
      var mesg2 = response?.result?.statusMessage?.split("|")[1]?.toLowerCase();
      var updateMsg = General?.codeLabels["cm_" + mesg]?.label;
      var replacedMsg;
      if (updateMsg?.includes("%1")) {
        replacedMsg = updateMsg?.replace("%1", mesg2);
      } else {
        replacedMsg = updateMsg;
      }
      NotifyError(replacedMsg);
      setSubmitLoader(false);
      return;
    } else {
      setTitle(General?.codeLabels['cm_socialcasesuccess']?.label?.replace('{0}', response?.result?.caseNo));
      setValue(3);
      const formData = new FormData();
      Object.keys(files).forEach((fileKey: any) => {
        const file: File = files[fileKey];
        formData.append("multiFileUpload", file, file.name);
      });
      setSubmitLoader(false);
      formData.append("data", JSON.stringify(upData));

      let res = await SocialCaseRequest.uploadSocialCaseDocuments({
        errorId: "uploadSocialCaseDocumentsError",
        data: formData,
      });

      if (res) {
        convertBlobToJson(res).then((data: any) => {
          setuploadDcumentStatus(data.result);
          if (data.result.orderId) {
          }
        });
      }
    }
  };

  useEffect(() => {
   User?.getServesis();
    const serviceId = User?.servesis?.find((element: any) => element?.serviceGuidePageLink?.toLowerCase() === "sccd" || element?.serviceGuidePageLink?.toLowerCase() === "socialcase")?.serviceGuideId;
    if (serviceId) {
     generalStore.incrementServiceUsage(serviceId);
    }  
  }, []);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const navigate = useNavigate();
  return (
    <div
      style={{
        backgroundColor: contrast?.contrastBackground
          ? contrast?.contrastBackground
          : "",
      }}
    >
      <MoveInHeader
        style={{
          background: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss === '#101E8E'?"#62aa51":ColorAss,
          color: contrast?.contrastColor ? contrast?.contrastColor : "",
        }}
        className={`${ColorAss === '#101E8E' ? 'GreenBgColorTree' : ''}`}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss === '#101E8E'?"#62aa51":ColorAss,

                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: "0",
              }}
              onClick={() =>
                navigate("/dashboard")
              }
            >
              {General?.codeLabels["cm_back"]?.label !== undefined
                ? General?.codeLabels["cm_back"]?.label
                : "BACK"}
            </ButtonSecondary>
            {User?.info?.personId && <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss === '#101E8E'?"#62aa51":ColorAss,

                width: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "12rem" : "117px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: "0",
              }}
              onClick={() => navigate("/dashboard")}
            >
              {General?.codeLabels["cm_dashboard"]?.label
                ? General?.codeLabels["cm_dashboard"]?.label
                : "DASHBOARD"}
            </ButtonSecondary>}
          </MiniNav>
          <h1
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: General?.isLargeScreen ? `${3.1 * General.accessibility.fontSize}rem` : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
          >
            {General?.codeLabels["cm_social_info"]?.label
              ? General?.codeLabels["cm_social_info"]?.label
              : "Request for Social Case Consideration"}
          </h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer
        style={{
          marginTop: value === 3 ? "1rem" : 0,
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
          width: General?.isLargeScreen ? "" : "98%",
        }}
      >
        <Box
          sx={{
            width:
              value === 3 ? "100%" : General?.isLargeScreen ? "80%" : "100%",
            paddingTop: value === 3 ? "0" : "1rem",
          }}
        >
          {value <= 2 && (
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                display: "flex",
                justifyContent: General?.isLargeScreen ? '' : "center"
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                sx={{ alignSelf: "flex-end", width: { md: '70%', lg: '100%' }, zIndex: "0" }}
                variant="scrollable"
                // scrollButtons
                allowScrollButtonsMobile
              >
                <Tab
                  label={
                    <TabWithCount value={value} count={1}  >
                      {General?.isLargeScreen && (
                        <span
                          style={{

                            fontSize: `${General.accessibility.fontSize}rem`,
                            color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
                          }}
                        >
                          {General?.codeLabels["cm_propertydet"]?.label !==
                            undefined
                            ? General?.codeLabels["cm_propertydet"]?.label
                            : "Property Details"}
                        </span>
                      )}
                    </TabWithCount>
                  }
                  className="mui-move-in"
                  {...a11yProps(0)}
                  sx={{
                    background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : ColorAss,
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    }
                  }}
                  disabled={preventOtherScreensState.socialDetails}
                />
                <Tab
                  label={
                    <TabWithCount count={2} value={value}>
                      {General?.isLargeScreen && (
                        <span
                          style={{

                            fontSize: `${General.accessibility.fontSize}rem`,
                            color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
                          }}
                        >
                          {General?.codeLabels["cm_social_detail"]?.label
                            ? General?.codeLabels["cm_social_detail"]?.label
                            : "Social Details"}
                        </span>
                      )}
                    </TabWithCount>
                  }
                  className="mui-move-in"
                  {...a11yProps(1)}
                  sx={{
                    background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : ColorAss,
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={preventOtherScreensState.socialDetails}
                />
                <Tab
                  label={
                    <TabWithCount count={3} value={value}>
                      {General?.isLargeScreen && (
                        <span
                          style={{

                            fontSize: `${General.accessibility.fontSize}rem`,
                              color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss
                          }}
                        >
                          {General?.codeLabels["cm_doc"]?.label
                            ? General?.codeLabels["cm_doc"]?.label
                            : "Documents"}
                        </span>
                      )}
                    </TabWithCount>
                  }
                  className="mui-move-in"
                  {...a11yProps(2)}
                  sx={{
                    background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : ColorAss,
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={preventOtherScreensState.uploadDcuments}
                />
              </Tabs>
            </Box>
          )}

          <TabPanel value={value} index={0}>
            <div
              style={{
                height: "50vh",
              }}
            >
              <p
                style={{
                  margin: "30px 0px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_enter_parcel"]?.label
                  ? General?.codeLabels["cm_enter_parcel"]?.label
                  : "Enter parcel number to start your application"}
              </p>
              <Error id="getParcelDetailsError" />
              <Formik
                initialValues={{
                  parcelId: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => {
                    setSubmitting(false);
                  }, 400);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Label
                      style={{
                            color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss
                          }}
                        >
                      {General?.codeLabels["cm_enterparcel"]?.label !== undefined
                        ? General?.codeLabels["cm_enterparcel"]?.label
                        : "Parcel Number"}
                      *
                    </Label>
                    <Label
                      style={{
                        color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        lineHeight: "16px",
                        gap: "0.5rem",
                        flexDirection: General?.isLargeScreen ? "row" : "column",
                        width: General?.isLargeScreen ? "" : "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          // alignItems: "center",
                          flexDirection: 'column',
                          width: General?.isLargeScreen ? "150%" : "100%",
                          gap: "1rem",
                        }}
                      >
                        <Field type="number" name='parcelId' innerRef={parcelNumberRef} maxlength="10" pattern="[0-9]*" style={{
                          color: contrast?.contrastColor ? contrast?.contrastBackground : ColorAss, 
                          background: contrast?.contrastBackground ? contrast?.contrastColor : "",
                          padding:"15px 10px",

                          fontSize: `${General.accessibility.fontSize}rem`,

                        }} />
                        <ErrorMessage
                          name="parcelId"
                          component="div"
                          className="error-message"
                        />
                      </div>
                      <ButtonSecondary
                        onClick={() => {
                          if (isEmpty(errors)) handleGetDetails();
                        }}
                        style={{
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          lineHeight: "16px",
                          width: General?.isLargeScreen ? "90%" : "100%",
                          height: "55px",
                          padding: "10px 0",
                          color: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : "#fff",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                          whiteSpace: "nowrap",
                          border:'none'
                        }}
                      >
                        {getDetailLoader ? (
                          <Spinner width="30px" height="30px" />
                        ) : General?.codeLabels["cm_registration_get_details"]
                          ?.label ? (
                          General?.codeLabels["cm_registration_get_details"]?.label
                        ) : (
                          "GET DETAILS"
                        )}
                      </ButtonSecondary>
                    </Label>
                  </form>
                )}
              </Formik>
            </div>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <SocialDetails
              socialCase={SocialCaseRequest.socialCase}
              onNext={onSocialDetailsNext}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Documents onSubmit={handleSubmit} submitLoader={submitLoader} />
          </TabPanel>
          <TabPanel value={value} index={3} width="100%">
            <Thankyou
              referenceId={caseIdRes}
              title={title}
              serviceID={1}
            />
          </TabPanel>
        </Box>
      </ComplaintContainer>
    </div>
  );
};

export default observer(SocialCase);
